module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('DialogBox', {
    attrs: {
      "settings": _vm.settings,
      "save-on-enter": ""
    },
    on: {
      "save": function($event) {}
    }
  }, [_c('div', {
    staticClass: "pa-4"
  }, [_c('GenericList', {
    attrs: {
      "items": _vm.items
    },
    on: {
      "click": _vm.listItemClicked
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6dfdb72e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/GenericListDialog.vue
// module id = 2593
// module chunks = 1